import styled from 'styled-components';
import Lora from '../../assets/customer-review-avatars/lora.png';
import Jordan from '../../assets/customer-review-avatars/jordan.png';
import Brandy from '../../assets/customer-review-avatars/brandy.png';
import Rita from '../../assets/customer-review-avatars/rita.png';
import Jessica from '../../assets/customer-review-avatars/jessica.png';
import Jie from '../../assets/customer-review-avatars/jie.png';
import StarsIcon from '../../assets/stars.png';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
const customerReviews = [
  {
    text: '“That would be so fun and so educational for kiddos”',
    avatar: Lora,
    name: '- Leann',
  },
  {
    text: '“I would love this!! I have a birdhouse birds nest in 2 to 3 times a year and I would love to see what is going on inside there”',
    avatar: Jordan,
    name: '- Patience',
  },
  {
    text: '“the camera setup was super easy! The mounting took a while only because we were indecisive on where to add it haha!”',
    avatar: Brandy,
    name: '- Andrew',
  }
];

// Styled Components
const Section = styled.div`
  background-color: #faf5f3;
  padding: 1rem 1.5rem 3rem; /* Less top padding, preserve bottom */
  @media (min-width: 768px) {
    padding: 2rem 5rem 5rem;
  }
`;

const Title = styled.h2`
  font-size: 1.875rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
  color: #b45309;
`;

const Subtitle = styled.p`
  color: #374151;
  margin-bottom: 2rem;
`;

const CarouselWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const Card = styled.div`
  background: #f1eae5;
  padding: 32px 28px 32px 28px;
  border-radius: 1.5rem;
  box-shadow: 0 4px 16px rgba(0,0,0,0.06);
  min-height: 380px;
  max-height: 450px;
  width: 370px;
  max-width: 370px;
  min-width: 370px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  text-align: left;
  @media (max-width: 767px) {
    margin: 0 auto;
    width: 90vw;
    min-width: unset;
    max-width: unset;
    min-height: 320px;
    max-height: unset;
    padding: 24px 10px;
  }
`;

const Stars = styled.span`
  background: #fff;
  border-radius: 9999px;
  padding: 0.25rem 0.5rem;
  display: flex;
  align-items: center;
  margin-bottom: 1.2rem;
  width: fit-content;
  align-self: flex-start;
`;

const ReviewText = styled.p`
  color: #374151;
  margin-bottom: 1.2rem;
  font-size: 1.1rem;
  font-weight: 400;
  text-align: left;
`;

const AvatarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  margin-top: auto;
  width: 100%;
`;

const Avatar = styled.img`
  width: 56px;
  height: 56px;
  border-radius: 9999px;
  margin-bottom: 0.5rem;
`;

const Name = styled.p`
  color: #374151;
  font-weight: 600;
  font-size: 1rem;
  margin: 0;
  text-align: left;
  width: 100%;
`;

export default function CustomerSay() {
  return (
    <Section>
      <Title>What our customers say about us</Title>
      <Subtitle>
        Don&apos;t just take our word for it. Here&apos;s how Sensforge cameras
        are making everyday life safer, simpler, and more connected for people
        like you.
      </Subtitle>
      <CarouselWrapper>
        <Splide
          options={{
            type: 'loop',
            gap: '1.2rem',
            perPage: 3,
            autoplay: true,
            interval: 5000,
            arrows: true,
            pagination: false,
            breakpoints: {
              1024: {
                perPage: 2,
              },
              767: {
                perPage: 1,
                width: '100%',
                focus: 'center',
              },
            },
          }}
        >
          {customerReviews.map((review, index) => (
            <SplideSlide key={index}>
              <Card>
                <Stars>
                  <img src={StarsIcon} alt="stars" />
                </Stars>
                <ReviewText>{review.text}</ReviewText>
                <AvatarWrapper>
                  <Avatar src={review.avatar} alt={review.name} />
                  <Name>{review.name}</Name>
                </AvatarWrapper>
              </Card>
            </SplideSlide>
          ))}
        </Splide>
      </CarouselWrapper>
    </Section>
  );
}